module.exports = __webpack_public_path__ + "static/media/logo.cf117692.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 220
// module chunks = 0